import React, { useState } from 'react';
import { LEAD_SUPERVISOR_ROLES, rpcError } from './config';
import { L } from './ui';

const ROLE_SUFFIX = { creador: ' (creador)', responsable: ' (responsable)', captador: ' (captador)' };

// Usuarios a los que se puede asignar un lead: supervisores y comerciales/captadores con el panel activado.
export function assignableUsers(profiles, accessRows) {
  const enabled = new Set((accessRows || []).filter(a => a.enabled).map(a => a.profile_id));
  return (profiles || [])
    .filter(p => LEAD_SUPERVISOR_ROLES.includes(p.role) || (['comercial', 'captador'].includes(p.role) && enabled.has(p.id)))
    .sort((a, b) => (a.full_name || '').localeCompare(b.full_name || '', 'es'));
}

// Selector "Asignar a…" (solo creador y responsable). Llama a assign_lead.
export default function AssignControl({ supabase, lead, profiles, accessRows, onDone, compact }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const users = assignableUsers(profiles, accessRows).filter(u => u.id !== lead.assigned_to);

  const assign = async (userId) => {
    if (!userId) return;
    setSaving(true); setError('');
    const { error: err } = await supabase.rpc('assign_lead', { p_lead_id: lead.id, p_user_id: userId });
    setSaving(false);
    if (err) { setError(rpcError(err)); return; }
    onDone?.();
  };

  return (
    <div style={{ display: 'grid', gap: '6px', flex: compact ? '1 1 180px' : undefined, maxWidth: compact ? '300px' : undefined }}>
      <select
        aria-label={lead.assigned_to ? 'Reasignar lead' : 'Asignar lead'}
        value=""
        disabled={saving || users.length === 0}
        onChange={e => assign(e.target.value)}
        style={{ ...L.input, marginBottom: 0, padding: compact ? '7px 8px' : '10px' }}
      >
        <option value="">{saving ? 'Asignando…' : users.length === 0 ? 'Nadie con el panel activado' : (lead.assigned_to ? '↪️ Reasignar a…' : '👤 Asignar a…')}</option>
        {users.map(u => <option key={u.id} value={u.id}>{u.full_name || 'Sin nombre'}{ROLE_SUFFIX[u.role] || ''}</option>)}
      </select>
      {error && <div style={{ ...L.error, margin: 0 }}>{error}</div>}
    </div>
  );
}
